import React, { useEffect, useMemo, useRef, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { useAppOrgContext } from "../../context/AppOrgContext";
import { useAuth0Context } from "../../context/Auth0Context";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import ThemeToggle from "../../Pages/AiApp/ThemeToggle";
import { getToolTipAttributes } from "../../utils/tooltip";
import "./Navbar.css";
import { getMenuByMode, getModulePath, groupedMenuData } from "./navbarUtils";
import Popover from "../Popover/Popover";
import ProfilePopover from "../Header/ProfilePopover";

const Navbar = () => {
  const params = useParams();
  const { mode, setMode } = useAppOrgContext();
  const [showProfile, setShowProfile] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState(null);
  const { user, resetAuthState } = useAuth0Context();
  const location = useLocation();
  const { appId, orgId } = params;
  const profileButtonRef = useRef();

  useEffect(() => {
    const currentPathSegment = location.pathname.split("/").filter(Boolean).pop();
    let matchedMode = null;

    for (const [mode, items] of Object.entries(groupedMenuData)) {
      const match = items.find((item) => item.route === currentPathSegment);
      if (match) {
        matchedMode = mode;
        break;
      }
    }

    if (matchedMode) {
      setMode(matchedMode);
    }
  }, [location.pathname, setMode]);

  const filteredScreens = useMemo(() => getMenuByMode(mode), [mode]);

  const handleLogout = async () => {
    try {
      await axiosInstance.post("/user/logout");
      resetAuthState();
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleProfileClick = (e) => {
    e.stopPropagation();
    const rect = profileButtonRef.current.getBoundingClientRect();
    setProfileAnchor({
      x: rect.right + 10,
      y: rect.top
    });
    setShowProfile(true);
  };

  return (
    <div className="navbar-section">
      <div className="builder_navbar">
        {filteredScreens.map((data) => (
          <NavLink
            key={data.name}
            to={getModulePath(data.route, orgId, appId)}
            className={({ isActive }) => (isActive ? "navmenu_btn active" : "")}
            style={{ pointerEvents: data.name === "Jobs" ? "none" : undefined }}
            {...getToolTipAttributes(data.name)}
          >
            <MaterialIcon name={data.iconName} />
          </NavLink>
        ))}
        <div className="d_flex flex_column align_center mt_auto gap_2">
          <ThemeToggle rotate={true} />
          <div
            ref={profileButtonRef}
            className="profile-dropdown-container"
            style={{ justifyContent: "space-around" }}
            onClick={handleProfileClick}
          >
            <MaterialIcon name="person" className="bottom_navbar_profile_icon" />
          </div>
        </div>
      </div>

      {showProfile && profileAnchor && (
        <Popover anchorPoint={profileAnchor} onClose={() => setShowProfile(false)}>
          <ProfilePopover
            user={user}
            onChangePassword={() => {
              setShowProfile(false);
            }}
            onLogout={handleLogout}
          />
        </Popover>
      )}
    </div>
  );
};

export default Navbar;
